import React, { useState } from 'react';
import { DropZone, Icons, IconSpinner } from '../../../components';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import {
  updateBannerImageToListing,
  uploadImageViaSharetribeSDK,
} from '../../ListingPage/ListingPage.duck';
import { getListingBannerImage } from '../../../util/dataExtractor';

import css from './SignupForm.module.css';
import { useConfiguration } from '../../../context/configurationContext';

function BrandWhiteLabelBanner({ listing, form }) {
  const dispatch = useDispatch();
  const [showDropZone, setShowDropZone] = useState(false);
  const [loading, setLoading] = useState(false);
  const config = useConfiguration();
  const [bannerImageState, setBannerImageState] = useState(getListingBannerImage(listing));

  const onUploadBannerImage = async files => {
    setLoading(true);
    try {
      const imageUrl = await dispatch(uploadImageViaSharetribeSDK(files));
      dispatch(
        updateBannerImageToListing({ bannerImage: imageUrl, listingId: listing?.id, config })
      );
      setBannerImageState(imageUrl); // Update local state immediately
      setShowDropZone(false);
    } catch (error) {
      console.error('Error uploading image:', error);
    } finally {
      setLoading(false);
    }
  };

  const onDeleteBannerImage = () => {
    form.change('bannerImage', null);
    dispatch(updateBannerImageToListing({ bannerImage: null, listingId: listing?.id, config }));
    setBannerImageState(null); // Remove immediately from UI
  };

  return (
    <div className={classNames(css.howItWorks, css.brandTopBanner)}>
      <p>
        <FormattedMessage id="BannerUpload.bannerTip" />
      </p>
      <div className={css.startContent}>
        <div className={css.sectionHead}>
          {showDropZone || !bannerImageState ? (
            <div className={css.leftSec}>
              {loading ? (
                <div className={css.loader}>
                  <IconSpinner showLightSpinner />
                </div>
              ) : (
                <div className={css.uploadImgSec}>
                  <DropZone onAttachmentUpload={onUploadBannerImage} />
                </div>
              )}
              <h2>
                <FormattedMessage id="BannerUpload.title" />
              </h2>
              <p>
                <FormattedMessage id="BannerUpload.description" />
              </p>
            </div>
          ) : (
            <div className={css.bannerWrapper}>
              {loading ? (
                <IconSpinner showLightSpinner />
              ) : (
                <div className={css.bannerImage}>
                  <img src={bannerImageState} alt="Banner" onClick={() => setShowDropZone(true)} />
                  <div className={css.deleteButton} role="button" onClick={onDeleteBannerImage}>
                    <Icons name="trash" />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BrandWhiteLabelBanner;
